import { SHFilterOption } from "@components/design-systems";
import { ToggleButtonOptions } from "@components/design-systems/sh-toggle-button-options/model";
import { AnalysisCommentDTO } from "@models/platform-analysis/entities/comment";
import { SummaryCommentSettingDto } from "@models/platform-analysis/entities/steps/summary";
import { FeatureAnalysisCollapseStateFilterLevel } from "@models/platform-analysis/enums/feature/featureAnalysisCollapseLevelFilter";
import { FeatureAnalysisEssentialFilterLevel } from "@models/platform-analysis/enums/feature/featureAnalysisEssentialFilter";
import { FeatureAnalysisAvailabilityFilterLevel } from "@models/platform-analysis/enums/feature/featureAnalysisFilter";
import { FeatureAnalysisScoreMode } from "@models/platform-analysis/enums/feature/featureAnalysisScoreMode";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import { FieldPath } from "react-hook-form";

export const AnalysisDynamicStepsOrder = [
  AnalysisStep.Feature,
  AnalysisStep.BusinessMetric,
  AnalysisStep.Fee,
];

export const FeatureAnalysisDisplayScoresOptions: ToggleButtonOptions[] = [
  { label: "Show scores", value: FeatureAnalysisScoreMode.Show },
  { label: "Hide", value: FeatureAnalysisScoreMode.Hide },
];

export const FeatureAnalysisAvailabilityFilterOptions: SHFilterOption[] = [
  {
    label: "All features",
    value: FeatureAnalysisAvailabilityFilterLevel.All,
  },
  {
    label: "Common (Features available on each platform)",
    value: FeatureAnalysisAvailabilityFilterLevel.Common,
  },
  {
    label: "Differentiators (Features not available on each platform)",
    value: FeatureAnalysisAvailabilityFilterLevel.Differentiators,
  },
];

export const FeatureAnalysisEssentialFeatureFilterOptions: SHFilterOption[] = [
  {
    label: "All features",
    value: FeatureAnalysisEssentialFilterLevel.All,
  },
  {
    label: "Features marked Essential",
    value: FeatureAnalysisEssentialFilterLevel.Essential,
  },
  {
    label: "Features not marked Essential",
    value: FeatureAnalysisEssentialFilterLevel.NonEssential,
  },
];

export const FeatureAnalysisCollapseLevelFilterOptions: SHFilterOption[] = [
  {
    label: "Feature group level",
    value: FeatureAnalysisCollapseStateFilterLevel.GroupLevel,
  },
  {
    label: "Feature sub-group level",
    value: FeatureAnalysisCollapseStateFilterLevel.SubGroupLevel,
  },
  {
    label: "Feature level",
    value: FeatureAnalysisCollapseStateFilterLevel.FeatureLevel,
  },
];

export const AnalysisCommentFieldPath: Partial<
  Record<AnalysisStep, FieldPath<AnalysisCommentDTO>>
> = {
  [AnalysisStep.Feature]: "feature",
  [AnalysisStep.BusinessMetric]: "businessMetric",
  [AnalysisStep.Fee]: "fee",
  [AnalysisStep.Summary]: "summary",
};

export const CommentSettingFieldPath: Partial<
  Record<AnalysisStep, FieldPath<SummaryCommentSettingDto>>
> = {
  [AnalysisStep.Feature]: "showFeature",
  [AnalysisStep.BusinessMetric]: "showBusinessMetric",
  [AnalysisStep.Fee]: "showFee",
  [AnalysisStep.Summary]: "showSummary",
};

export const CommentProductColWidthPercent = 14;
export const CommentFeatureMatchColWidthPercent = 8;
export const MaximumProductInAppendixTable = 7;
